let electron = window.require("electron");
let mainBrowserWindow: any = null;

export default function getMainBrowserWindow(): any {
    if (null === mainBrowserWindow) {
        mainBrowserWindow = electron && electron.remote && electron.remote.getCurrentWindow();
    }

    return mainBrowserWindow;
}